var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
        tag: true,
        'tag--competency': _vm.tag.type === 'competence',
    }},[_vm._v("\n    "+_vm._s(_vm.tag.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }